import { render } from "./VideoVerificationSuccess.vue?vue&type=template&id=35629330&scoped=true"
import script from "./VideoVerificationSuccess.vue?vue&type=script&lang=js"
export * from "./VideoVerificationSuccess.vue?vue&type=script&lang=js"

import "./VideoVerificationSuccess.vue?vue&type=style&index=0&id=35629330&lang=scss&scoped=true"

import exportComponent from "D:\\Epaylater Projects\\microapp-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35629330"]])

export default __exports__